const isLogged = () => !!localStorage.getItem('userKey')
export { isLogged };
